// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"385":"c899cebe","778":"e7f002fd","922":"7f4a6451"}[chunkId] + ".chunk.js";
};